/**
 * Checks if the desktop app cache validity is invalid or expired.
 *
 * @param desktopAppNoticeCache The desktop app notice cache.
 */
export function isDesktopAppCacheInvalidOrExpired(desktopAppNoticeCache) {
    if (desktopAppNoticeCache.expiresAt &&
        Date.now() < desktopAppNoticeCache.expiresAt) {
        return false;
    }
    return true;
}
